import * as Dialog from "@radix-ui/react-dialog";
import { useState } from "react";
import { ReactComponent as CloseIcon } from "assets/img/icons/header/close.svg";
import { Separator } from "components/elements";
import { NewConversation } from "./NewConversation";

interface ConversationDropdownProps {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
}

export const ConversationDropdown = ({ isOpen, setIsOpen }: ConversationDropdownProps) => {
    return (
        <Dialog.Root open={isOpen} onOpenChange={setIsOpen}>
            {isOpen && (
                <Dialog.Portal>
                    <div
                        className="fixed inset-0 z-40 bg-black/50"
                        onClick={() => setIsOpen(false)}
                    ></div>

                    <Dialog.Content className="fixed left-1/2 top-1/2 z-50 w-[500px] -translate-x-1/2 -translate-y-1/2 rounded-2xl bg-white px-6 py-4 shadow-none">
                        <div className=" mx-auto flex flex-col">
                            <div className="mb-3 flex flex-row items-center justify-between">
                                <Dialog.Title className="font-sans text-[24px] font-bold text-[#424242]">
                                    New conversation with:
                                </Dialog.Title>
                                <Dialog.Close asChild>
                                    <button className="text-gray-500 hover:text-gray-700">
                                        <CloseIcon className="-mt-2 h-[30px] w-[30px]" />
                                    </button>
                                </Dialog.Close>
                            </div>

                            <Separator className="-mx-[24px] mt-0 mb-5" />
                        </div>
                        <NewConversation setIsOpen={setIsOpen} />
                    </Dialog.Content>
                </Dialog.Portal>
            )}
        </Dialog.Root>
    );
};
